import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Utilities } from 'src/app/core/helper/util';
import { MediaLibraryComponent } from '../../modal/media-library/media-library.component';
import { Log } from 'src/app/core/log';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AppSettings } from 'src/app/core/configs/app.settings';

@Component({
  selector: 'app-add-image',
  templateUrl: './add-image.component.html',
  styleUrls: ['./add-image.component.scss'],
})
export class AddImageComponent implements OnInit {

  @Input() someObject: any;
  @Input() imgProperty: string;
  @Input() maxImages: number = 1;
  @Input() sizeRecommendation: string = '500px by 500px';

  @Input() height: string = '250px';
  @Input() width: string = '250px';
  @Input() includeLibraryButton: boolean = true;
  @Output() imageChanged: EventEmitter<string> = new EventEmitter();

  resizedFilePath: string; // path to local, in-memory file
  resizedFileBase64: string;
  resizedFileSize: string;

  randomId: string = Utilities.getRandomString(5);

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  upload() {
    document.getElementById(this.randomId).click();
  }

  // Called after file browser pops up and user selects a file.
  async onFileSelected(event: any) {
    Log.debug('file selected...')
    const file: File = event.target.files[0];
    if (file) {
      // check file size
      const sizeInMb = Math.floor((file.size / 1024) / 1024);
      if (sizeInMb > AppSettings.maxImageSizeMB) {
        ServiceHelper.displayAlert('Image Too Large.', `File size must be less than ${AppSettings.maxImageSizeMB}MB`);
        return;
      }

      // convert to blob for our image resizer
      const blob = new Blob([file], { type: file.type });

      // image resizer does it's thing and returns the path to an in-memory image file 
      // this.resizedFilePath = await Utilities.resizeImage(blob, 1600, 1200) as string;
      this.resizedFilePath = URL.createObjectURL(blob);

      // now read the base64 from that in-memory image file
      this.resizedFileBase64 = await Utilities.getBase64FromDataUrl(this.resizedFilePath);

      if (this.someObject != null) {
        if (Utilities.stringEmpty(this.someObject[this.imgProperty]) || this.maxImages == 1) {
          this.someObject[this.imgProperty] = this.resizedFileBase64;
        } else {
          this.someObject[this.imgProperty] += '|' + this.resizedFileBase64
        }
      }

      this.imageChanged.emit(this.resizedFileBase64)

      // reset input
      this.resizedFilePath = undefined;
      this.resizedFileBase64 = undefined;

      // so we can select same file again
      event.target.value = null;

    }
  }

  async library() {
    var existingImgs = [];

    if (this.someObject != null && !Utilities.stringEmpty(this.someObject[this.imgProperty])) {
      existingImgs = this.someObject[this.imgProperty].split('|');
    }

    const libraryModal = await this.modalCtrl.create({
      component: MediaLibraryComponent,
      cssClass: 'bigger-modal', // argh!!! why you no worky?!
      componentProps: {
        maxImages: this.maxImages,
        alreadyAdded: existingImgs
      }
    });
    libraryModal.present();
    libraryModal.onDidDismiss().then(e => {
      if (e.data != null && e.data.selectedImgs != null && e.data.selectedImgs.length > 0) {

        e.data.selectedImgs.forEach(img => {
          existingImgs.push(img.path);
        });
        if (this.someObject != null) {
          this.someObject[this.imgProperty] = existingImgs.join('|')
        }

        this.imageChanged.emit(existingImgs.join('|'))
      }
    })
  }

}
